import "./clientSettings.scss";

import { observer, useLocalObservable } from "mobx-react";
import { Form, Modal, Layout, Select, Tag, Tooltip, Button, Popconfirm } from "antd";
import { translateKey as t } from "../../../../../../locales/translation";
import MenuOptions from "./MenuOptions";
import FormContent from "./FormContent";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import dayjs from "dayjs";
import _ from "lodash";
import { ClockCircleOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEdit, faUpload } from "@fortawesome/free-solid-svg-icons";

const { Sider, Content, Header } = Layout;

const ClientSettingsModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (controller.selectedDates && controller.selectedDates.length > 0) {
      form.setFields([
        {
          name: "dates",
          errors: [],
        },
      ]);
    }
  }, [controller.selectedDates, form]);

  const state = useLocalObservable(() => ({}));

  const handleOK = () => {
    console.log("Submit");
    controller.setClientSettingsModal("compareModalVisible", true);
  };

  const handleCancel = () => {
    store.clearClient();
    // form.resetFields();
    controller.setClientSettingsModal(null, {
      visible: false,
      loading: false,
      row: null,
      dataStructure: [],
      selectedOption: null,
      backups: [],
      currentProfile: null,
      editProfile: null,
      editMode: false,
      compareModalVisible: false,
    });
    controller.setSelectedDepots([]);
  };

  const renderHeader = () => {
    const { editProfile, backups } = controller.clientSettingsModal;

    if (editProfile === null) {
      return null;
    }

    let lastUpdate = dayjs(_.get(editProfile, "createdAt")).format("DD/MM/YYYY HH:mm");

    return (
      <div style={{ textAlign: "center", marginTop: 0, display: "flex", justifyContent: "center" }}>
        <div style={{ marginRight: 10 }}>
          <b style={{ marginRight: 5 }}>Current Profile:</b>
          <Tooltip
            title={
              <>
                <ClockCircleOutlined style={{ marginRight: 5 }} /> Update At: {lastUpdate}
              </>
            }
            placement="bottom"
          >
            <Tag color="#2563EB">{editProfile?.profileName ? editProfile.profileName : "N/A"}</Tag>
          </Tooltip>
        </div>
        <div>
          <b style={{ marginRight: 5 }}>Available Backups:</b>

          <Select
            size={"small"}
            showSearch
            placeholder="Select a backup"
            optionFilterProp="label"
            // onChange={onChange}
            // onSearch={onSearch}
            options={backups}
          />
        </div>
      </div>
    );
  };

  const renderFooter = () => {
    let footer = [
      <Button key="return" type="primary" icon={<FontAwesomeIcon icon={faAngleLeft} />} onClick={handleCancel}>
        {t("lblCancel", "Cancel")}
      </Button>,
    ];

    if (controller.clientSettingsModal?.editMode) {
      footer.push(
        <Button key="upload" onClick={() => handleOK()} icon={<FontAwesomeIcon icon={faUpload} />}>
          {t("lblSubmit", "Submit")}
        </Button>
      );
    } else {
      footer.push(
        <Button key="update" onClick={() => controller.setClientSettingsModal("editMode", true)} icon={<FontAwesomeIcon icon={faEdit} />}>
          {t("lblUpdate", "Update")}
        </Button>
      );
    }

    return footer;
  };

  if (!controller.clientSettingsModal.visible) {
    return null;
  }

  return (
    <Modal
      title={"Client Settings - " + controller.clientSettingsModal?.row?.clientRef}
      open={controller.clientSettingsModal.visible}
      footer={renderFooter()}
      onCancel={handleCancel}
      okType="primary"
      onOk={handleOK}
      maskClosable={false}
      className={"clientSettingsModal"}
      okButtonProps={{ disabled: controller.postTypes.length === 0 }}
      width={"95vw"}
      centered={true}
      styles={{
        header: { borderBottom: "1px solid #0505050f", paddingBottom: 10 },
        body: {
          height: "80vh",
          overflow: "hidden",
        },
      }}
    >
      <Layout style={{ display: "flex", height: "100%" }}>
        <Sider width={200} className={"clientSettingsSider"}>
          <MenuOptions controller={controller} store={store} />
        </Sider>

        <Layout>
          <Header className="clientSettingsHeader">{renderHeader()}</Header>
          <Content
            className="clientSettingsContent"
            style={{
              overflowY: "auto",
            }}
          >
            <FormContent controller={controller} store={store} />
          </Content>
        </Layout>
      </Layout>
    </Modal>
  );
});

export default ClientSettingsModal;
